import { STARTUP_ROLES } from './constants';


/** ********************************************** IG_BUILD **************************************** */
const SHOW_BUILD_ALLOWED_ROLES = [
  STARTUP_ROLES.STAFF, STARTUP_ROLES.CEO, STARTUP_ROLES.CO_FOUNDER, STARTUP_ROLES.INVESTOR_LEADER,
  STARTUP_ROLES.BOARD_MEMBER, STARTUP_ROLES.BOARD_OF_DIRECTOR, STARTUP_ROLES.FREELANCER,
  STARTUP_ROLES.MENTOR, STARTUP_ROLES.ADVISOR, STARTUP_ROLES.ADVISORY_SERVICE,
];
/** ************************************************************************************************** */


/** ********************************************** IG_IDEA **************************************** */
const SHOW_IDEA_ALLOWED_ROLES = [
  STARTUP_ROLES.STAFF, STARTUP_ROLES.CEO, STARTUP_ROLES.CO_FOUNDER, STARTUP_ROLES.INVESTOR_LEADER,
  STARTUP_ROLES.BOARD_MEMBER, STARTUP_ROLES.BOARD_OF_DIRECTOR,
  STARTUP_ROLES.MENTOR, STARTUP_ROLES.ADVISOR, STARTUP_ROLES.ADVISORY_SERVICE,
];
/** ************************************************************************************************** */


/** ********************************************** IG_TASKS **************************************** */
const SHOW_TASKS_ALLOWED_ROLES = [
  STARTUP_ROLES.STAFF, STARTUP_ROLES.CEO, STARTUP_ROLES.CO_FOUNDER, STARTUP_ROLES.INVESTOR_LEADER,
  STARTUP_ROLES.FREELANCER,
];
/** ************************************************************************************************** */


/** ********************************************** IG_SUPPORT **************************************** */
const SHOW_SUPPORT_ALLOWED_ROLES = [
  STARTUP_ROLES.STAFF, STARTUP_ROLES.CEO, STARTUP_ROLES.CO_FOUNDER, STARTUP_ROLES.INVESTOR_LEADER,
  STARTUP_ROLES.FREELANCER, STARTUP_ROLES.MENTOR,
];
const EDIT_FEEDBACK_CHAIN_ALLOWED_ROLES = [
  STARTUP_ROLES.CEO, STARTUP_ROLES.CO_FOUNDER, STARTUP_ROLES.LEADER, STARTUP_ROLES.STAFF,
  STARTUP_ROLES.FREELANCER,
];

/** ************************************************************************************************** */

/** ********************************************** IG_EXECUTION **************************************** */
const SHOW_EXECUTION_ALLOWED_ROLES = [
  STARTUP_ROLES.STAFF, STARTUP_ROLES.CEO, STARTUP_ROLES.CO_FOUNDER,
];
/** ************************************************************************************************** */


/** ********************************************** IG_CEO **************************************** */
const SHOW_CEO_ALLOWED_ROLES = [
  STARTUP_ROLES.CEO, STARTUP_ROLES.CO_FOUNDER, STARTUP_ROLES.BOARD_OF_DIRECTOR,
  STARTUP_ROLES.INVESTOR_LEADER,
];
/** ************************************************************************************************** */


/** ********************************************** AFFILLIATION **************************************** */
const SHOW_AFFILIATION_ALLOWED_ROLES = [
  STARTUP_ROLES.CEO, STARTUP_ROLES.CO_FOUNDER,
];
/** ************************************************************************************************** */


/** ********************************************** BUSINESS **************************************** */
const SHOW_BUSINESS_ALLOWED_ROLES = [
  STARTUP_ROLES.STAFF, STARTUP_ROLES.BMC_LEADER, STARTUP_ROLES.CO_FOUNDER, STARTUP_ROLES.CEO,
  STARTUP_ROLES.BOARD_OF_DIRECTOR, STARTUP_ROLES.INVESTOR_LEADER, STARTUP_ROLES.MENTOR,
  STARTUP_ROLES.ADVISORY_SERVICE, STARTUP_ROLES.ADVISORY_BOARD,
];


const EDIT_BUSINESS_ALLOWED_ROLES = [
  STARTUP_ROLES.BMC_LEADER, STARTUP_ROLES.CEO, STARTUP_ROLES.CO_FOUNDER,
];
/** ************************************************************************************************** */


/** ********************************************** INFRASTRUCTURE **************************************** */
const SHOW_INFRASTRUCTURE_ALLOWED_ROLES = [
  STARTUP_ROLES.STAFF, STARTUP_ROLES.CO_FOUNDER, STARTUP_ROLES.CEO, STARTUP_ROLES.BOARD_OF_DIRECTOR,
  STARTUP_ROLES.FREELANCER,
];
/** ************************************************************************************************** */


/** ********************************************** IG_TEAM **************************************** */
const SHOW_TEAM_ALLOWED_ROLES = [
  STARTUP_ROLES.STAFF, STARTUP_ROLES.CO_FOUNDER, STARTUP_ROLES.CEO, STARTUP_ROLES.BOARD_OF_DIRECTOR,
];
/** ************************************************************************************************** */


/** ********************************************** IG_BOARDS **************************************** */
const SHOW_BOARD_ALLOWED_ROLES = [
  STARTUP_ROLES.CO_FOUNDER, STARTUP_ROLES.CEO, STARTUP_ROLES.BOARD_OF_DIRECTOR, STARTUP_ROLES.STAFF,
  STARTUP_ROLES.INVESTOR_LEADER, STARTUP_ROLES.BOARD_MEMBER,
];
/** ************************************************************************************************** */


/** ********************************************** IG_MEETINGS **************************************** */
const SHOW_MEETINGS_ALLOWED_ROLES = [
  STARTUP_ROLES.CO_FOUNDER, STARTUP_ROLES.CEO,
];
/** ************************************************************************************************** */


/** ********************************************** IG_STARTUP **************************************** */
const SHOW_STARTUP_CARD_ALLOWED_ROLES = [
  STARTUP_ROLES.STAFF, STARTUP_ROLES.CO_FOUNDER, STARTUP_ROLES.CEO, STARTUP_ROLES.BOARD_OF_DIRECTOR,
  STARTUP_ROLES.INVESTOR, STARTUP_ROLES.FREELANCER, STARTUP_ROLES.BOARD_MEMBER,
  STARTUP_ROLES.INVESTOR_LEADER, STARTUP_ROLES.MENTOR, STARTUP_ROLES.ADVISOR, STARTUP_ROLES.GUEST,
];
const EDIT_STARTUP_ALLOWED_ROLES = [
  STARTUP_ROLES.CEO,
];
const EDIT_WEB_ALLOWED_ROLES = [
  STARTUP_ROLES.CEO,
];
/** ************************************************************************************************** */

/** ********************************************** IG_PITCH **************************************** */
const SHOW_PITCH_ALLOWED_ROLES = [
  STARTUP_ROLES.CO_FOUNDER, STARTUP_ROLES.CEO,
];
/** ************************************************************************************************** */


export {
  SHOW_BUILD_ALLOWED_ROLES,
  SHOW_TASKS_ALLOWED_ROLES,
  SHOW_SUPPORT_ALLOWED_ROLES,
  SHOW_EXECUTION_ALLOWED_ROLES,
  SHOW_CEO_ALLOWED_ROLES,
  SHOW_AFFILIATION_ALLOWED_ROLES,
  SHOW_BUSINESS_ALLOWED_ROLES,
  SHOW_INFRASTRUCTURE_ALLOWED_ROLES,
  SHOW_TEAM_ALLOWED_ROLES,
  SHOW_BOARD_ALLOWED_ROLES,
  SHOW_MEETINGS_ALLOWED_ROLES,
  SHOW_STARTUP_CARD_ALLOWED_ROLES,
  SHOW_IDEA_ALLOWED_ROLES,
  SHOW_PITCH_ALLOWED_ROLES,
  EDIT_STARTUP_ALLOWED_ROLES,
  EDIT_WEB_ALLOWED_ROLES,
  EDIT_BUSINESS_ALLOWED_ROLES,
  EDIT_FEEDBACK_CHAIN_ALLOWED_ROLES,
};
